import { NanFetch } from "API/basic/get";
import { product } from "API/product/product";
import { settings } from "API/settings/settings";
import { categories } from "./categories";
import { login } from "./login";
import { pages } from "./pages";
import { form } from "API/form/form";

export const API = {
  // ...axios_get,
  ...NanFetch,
  pages,
  form,
  categories,
  product,
  login,
  settings
};